import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navigation from "./components/Navigation";
import RequireState from "./components/sections/RequireState";
import { HomeSection } from "./components/sections/HomeSection";
import { PricesTable } from "./components/sections/PricesSection";
import { AboutSection } from "./components/sections/AboutSection";
import { ContactsSection } from "./components/sections/ContactSection";
import { HelpSection } from "./components/sections/HelpSection";
import { BookingPage } from "./components/sections/BookingPage";
import { BookingSummary } from "./components/sections/BookingSummaryProps";
import { CheckoutPayment } from "./components/sections/CardPayment";
import PaymentSuccess from "./components/sections/PaymentSuccess";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { Terms } from "./components/Terms";
import { Cookies } from "./components/Cookies";
import { RouteLandingPage } from "./components/sections/RouteLandingPage";
import Footer from "./components/Footer";
import "./App.css";

export default function App() {
  return (
    <Router>
      <div className="app-container">
        <Navigation />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomeSection />} />
            <Route path="/prices" element={<PricesTable />} />
            <Route path="/about" element={<AboutSection />} />
            <Route path="/contacts" element={<ContactsSection />} />
            <Route path="/help" element={<HelpSection />} />
            <Route path="/booking" element={<BookingPage />} />

            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />

            <Route
              path="/booking-summary/:bookingId"
              element={<BookingSummary />}
            />

            <Route
              path="/payment/checkout"
              element={
                <RequireState redirectTo="/booking">
                  <CheckoutPayment />
                </RequireState>
              }
            />

            <Route
              path="/payment/success"
              element={<PaymentSuccess />}
            />

            {/* SEO Landing Pages */}
            <Route
              path="/routes/:routeSlug"
              element={<RouteLandingPage />}
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}